<template>
    <div class="col-12">
        <div class="card h-auto mb-3" aria-hidden="true">
            <div class="card-body">
                <h5 class="card-title placeholder-glow">
                    <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 mb-3"></a>
            </div>
        </div>
        <div class="card h-auto mb-3" aria-hidden="true">
            <div class="card-body">
                <h5 class="card-title placeholder-glow">
                    <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 mb-3"></a>
            </div>
        </div>
        <div class="card h-auto mb-3" aria-hidden="true">
            <div class="card-body">
                <h5 class="card-title placeholder-glow">
                    <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 mb-3"></a>
            </div>
        </div>
        <div class="card h-auto mb-3" aria-hidden="true">
            <div class="card-body">
                <h5 class="card-title placeholder-glow">
                    <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                </p>
                <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 mb-3"></a>
            </div>
        </div>
    </div>
</template>